/*
  SENTYR SKIN — el-pdp.js
  Fiche produit (el-product-og), FAQ (el-richtext) et barre collante (el-sticky-atc).
  Port vanilla de la logique Penrose (el-common.js + el-pdp.js + scripts inline) :
  - sliders Slick si jQuery + Slick sont chargés par layout/theme.liquid (attribut data-el-slider-config, propre à ce fichier
    pour ne pas entrer en conflit avec l'init générique data-slider-config de el-common.js) ; galerie de secours sinon ;
  - choix d'offre (data_tab), sélecteur de senteur par pot, tiroir « Guide des senteurs », accordéons, ajout panier /cart/add.js ;
  - dates calculées en jours ouvrés ([data-el-date-days]) ; apparition de la barre collante (IntersectionObserver).
  Les clics sont interceptés en phase de capture, uniquement dans les racines [data-el-pdp], pour que les handlers jQuery
  délégués au document (el-common.js) ne se déclenchent pas une seconde fois.
*/
(function () {
  'use strict';
  if (window.__elPdpInit) return;
  window.__elPdpInit = true;

  var FR_DAYS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var FR_MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  /* ---------- Dates (jours ouvrés, lundi → vendredi) ---------- */
  function addBusinessDays(n) {
    var d = new Date();
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }
  function formatDate(d, mode) {
    if (mode === 'weekday') return FR_DAYS[d.getDay()];
    return FR_DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + FR_MONTHS[d.getMonth()];
  }
  function fillDates() {
    document.querySelectorAll('[data-el-date-days]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-el-date-days'), 10);
      if (isNaN(n) || n < 0) n = 1;
      el.textContent = formatDate(addBusinessDays(n), el.getAttribute('data-el-date-format') || 'long');
    });
  }

  /* ---------- Sliders ---------- */
  function initSliders(attempt) {
    var sliders = document.querySelectorAll('[data-el-slider-config]');
    if (!sliders.length) return;
    if (!(window.jQuery && window.jQuery.fn && window.jQuery.fn.slick)) {
      if ((attempt || 0) < 20) {
        setTimeout(function () { initSliders((attempt || 0) + 1); }, 250);
        return;
      }
      document.querySelectorAll('.el-element-product-media').forEach(function (g) {
        if (g.classList.contains('el-no-slick')) return;
        g.classList.add('el-no-slick');
        var first = g.querySelector('.el-product-media-main-item');
        if (first) first.classList.add('el-current');
        var thumb = g.querySelector('.el-product-media-thumb-item');
        if (thumb) thumb.classList.add('slick-current');
      });
      return;
    }
    sliders.forEach(function (el) {
      var $el = window.jQuery(el);
      if ($el.hasClass('slick-initialized')) return;
      try {
        var config = JSON.parse(el.getAttribute('data-el-slider-config'));
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { config.speed = 0; config.autoplay = false; }
        $el.slick(config);
      } catch (err) {
        if (window.console) console.warn('el-pdp: slider', err);
      }
    });
  }
  function fallbackThumb(thumb) {
    var gallery = thumb.closest('.el-element-product-media');
    if (!gallery || !gallery.classList.contains('el-no-slick')) return false;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.el-product-media-thumb-item'));
    var idx = thumbs.indexOf(thumb);
    gallery.querySelectorAll('.el-product-media-main-item').forEach(function (it, i) { it.classList.toggle('el-current', i === idx); });
    thumbs.forEach(function (t, i) { t.classList.toggle('slick-current', i === idx); });
    return true;
  }
  function inlineVideos() {
    document.querySelectorAll('[data-el-pdp] video').forEach(function (v) {
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.muted = true;
    });
  }

  /* ---------- Une seule sélection pour le configurateur et la barre fixe ---------- */
  function currentOffer(root) { return root.querySelector('.sentyr-offer.active'); }
  function selectedPots(root) {
    var offer = currentOffer(root);
    return offer ? Array.from(offer.querySelectorAll('.el-product-option')) : [];
  }
  function selectionAvailable(root) {
    var offer = currentOffer(root);
    var pots = selectedPots(root);
    return !!offer && pots.length === Number(offer.dataset.count) && pots.every(function (pot) {
      return Number(pot.getAttribute('variant_id')) > 0 && pot.dataset.available === 'true';
    });
  }
  function syncSelection(root, announce) {
    var offer = currentOffer(root);
    if (!offer) return;
    var count = Number(offer.dataset.count);
    var available = selectionAvailable(root);
    var total = root.querySelector('[data-selection-total]');
    var detail = root.querySelector('[data-selection-detail]');
    var saving = root.querySelector('[data-selection-saving]');
    if (total) total.textContent = offer.dataset.total;
    if (detail) detail.textContent = count + (count === 1 ? ' pot' : ' pots') + ' · ' + offer.dataset.perPot + ' / pot';
    if (saving) {
      saving.hidden = count === 1;
      saving.textContent = 'Économie : ' + offer.dataset.saving + ' par rapport aux pots à l’unité.';
    }
    root.querySelectorAll('.sentyr-offer-radio, .sentyr-scent-select').forEach(function (control) { control.disabled = !!root.__elAdding; });
    var button = root.querySelector('.el-checkout-button');
    if (button) {
      button.disabled = !!root.__elAdding || !available;
      button.setAttribute('aria-busy', root.__elAdding ? 'true' : 'false');
      button.classList.toggle('el-loading', !!root.__elAdding);
      var label = button.querySelector('[data-atc-label]');
      if (label) label.textContent = root.__elAdding ? 'Ajout en cours…' : available ? root.dataset.atcLabel : 'Une senteur est indisponible';
    }
    document.querySelectorAll('.el-sticky-atc').forEach(function (sticky) {
      var totalLabel = sticky.querySelector('[data-sticky-total]');
      var selectionLabel = sticky.querySelector('[data-sticky-selection]');
      var stickyButton = sticky.querySelector('.el-sticky-atc-js');
      var actionLabel = sticky.querySelector('[data-sticky-label]');
      if (totalLabel) totalLabel.textContent = offer.dataset.total;
      if (selectionLabel) {
        var quantityLabel = count + (count === 1 ? ' pot' : ' pots');
        var firstPot = selectedPots(root)[0];
        var selectionTitle = count === 1 && firstPot ? firstPot.dataset.title : offer.dataset.title;
        selectionLabel.textContent = selectionTitle && selectionTitle !== quantityLabel ? selectionTitle + ' · ' + quantityLabel : quantityLabel;
      }
      if (stickyButton) {
        stickyButton.disabled = !!root.__elAdding || !available;
        stickyButton.setAttribute('aria-busy', root.__elAdding ? 'true' : 'false');
      }
      if (actionLabel) actionLabel.textContent = root.__elAdding ? 'Ajout en cours…' : available ? 'Ajouter ma sélection' : 'Senteur indisponible';
    });
    if (announce) {
      var status = root.querySelector('[data-selection-status]');
      if (status) status.textContent = selectedPots(root).map(function (pot, index) { return 'Pot ' + (index + 1) + ' : ' + pot.dataset.title; }).join('. ') + (available ? '.' : '. Choisis une senteur disponible.');
    }
  }
  function activateOption(opt, updateUrl) {
    var root = opt.closest('.el-product');
    if (!root || root.__elAdding) return;
    root.querySelectorAll('.sentyr-offer').forEach(function (offer) {
      var selected = offer === opt;
      offer.classList.toggle('active', selected);
      var radio = offer.querySelector('.sentyr-offer-radio');
      var panel = offer.querySelector('.sentyr-offer-pots');
      if (radio) radio.checked = selected;
      if (panel) panel.hidden = !selected;
    });
    setError(root, '');
    syncSelection(root, true);
    if (updateUrl) {
      var url = new URL(window.location.href);
      url.searchParams.set('offer', opt.getAttribute('data_tab'));
      window.history.replaceState(window.history.state, '', url);
    }
  }
  function selectScent(select, announce) {
    var pot = select.closest('.el-product-option');
    var option = select.options[select.selectedIndex];
    if (!pot) return;
    pot.setAttribute('variant_id', option ? option.value : '');
    pot.dataset.available = option ? option.dataset.available : 'false';
    pot.dataset.title = option ? option.dataset.title : 'Aucune senteur';
    var root = select.closest('.el-product');
    setError(root, '');
    syncSelection(root, announce);
  }

  /* ---------- Accordéons ---------- */
  function toggleFaq(q) {
    var answer = q.nextElementSibling;
    var isOpen = q.classList.contains('active');
    var scope = q.closest('[data-el-pdp]') || document;
    scope.querySelectorAll('.el-question.active').forEach(function (o) {
      if (o === q) return;
      o.classList.remove('active');
      o.setAttribute('aria-expanded', 'false');
      if (o.nextElementSibling) o.nextElementSibling.style.display = 'none';
    });
    q.classList.toggle('active', !isOpen);
    q.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    if (answer) answer.style.display = isOpen ? 'none' : '';
  }

  /* ---------- Dialog natif : Échap, focus captif et arrière-plan inert ---------- */
  function openGuide(root, trigger) {
    var dialog = root && root.querySelector('.el-drawer-guide');
    if (!dialog) return;
    if (typeof dialog.showModal !== 'function') { window.location.href = '/pages/guide-des-senteurs'; return; }
    dialog.__elTrigger = trigger;
    dialog.classList.add('active');
    dialog.showModal();
    document.body.classList.add('el-overflow-hidden');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var close = dialog.querySelector('.el-mobile-guide-close');
    if (close) close.focus();
  }
  function guideClosed(dialog) {
    dialog.classList.remove('active');
    document.body.classList.remove('el-overflow-hidden');
    if (dialog.__elTrigger && dialog.__elTrigger.isConnected) {
      dialog.__elTrigger.setAttribute('aria-expanded', 'false');
      dialog.__elTrigger.focus({ preventScroll: true });
    }
  }
  function closeGuide(dialog) {
    if (dialog && dialog.open) dialog.close();
  }
  function trapGuideFocus(event, dialog) {
    if (event.key !== 'Tab' || !dialog.open) return;
    var items = Array.from(dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (item) {
      return item.getClientRects().length && !item.closest('[inert], [aria-hidden="true"]') && item.tabIndex >= 0;
    });
    var first = items[0], last = items[items.length - 1];
    if (!first) { event.preventDefault(); return; }
    var active = document.activeElement;
    if (!dialog.contains(active) || active === dialog) { event.preventDefault(); (event.shiftKey ? last : first).focus(); }
    else if (event.shiftKey && active === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && active === last) { event.preventDefault(); first.focus(); }
  }

  /* ---------- Ajout au panier ---------- */
  function setError(root, msg) {
    var box = root.querySelector('.el-atc-error');
    if (!box) return;
    box.textContent = msg || '';
    box.style.display = msg ? 'block' : 'none';
  }
  function cartAddUrl() {
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return rootPath.replace(/\/?$/, '/') + 'cart/add.js';
  }
  function openCart(json, trigger) {
    var opened = false;
    /* 1. tiroir panier du socle SENTYR (el-common.js expose elOpenCart / refreshCartDrawer, bouton .el-cart-button) */
    if (typeof window.elOpenCart === 'function') {
      try { window.elOpenCart(trigger, { afterAdd: true }); opened = true; } catch (e0) { opened = false; }
    }
    if (!opened && typeof window.refreshCartDrawer === 'function') {
      try { window.refreshCartDrawer(); } catch (e1) { /* silencieux */ }
    }
    if (!opened && document.querySelector('.el-cart-drawer-js') && document.querySelector('.el-cart-button')) {
      try { document.querySelector('.el-cart-button').click(); opened = true; } catch (e2) { opened = false; }
    }
    /* 2. tiroir Dawn natif (<cart-drawer>) */
    var drawer = document.querySelector('cart-drawer');
    if (!opened && drawer) {
      if (typeof drawer.renderContents === 'function' && json && json.sections) {
        try { drawer.renderContents(json); opened = true; } catch (e3) { opened = false; }
      }
      if (!opened && typeof drawer.open === 'function') {
        try { drawer.open(); opened = true; } catch (e4) { opened = false; }
      }
    }
    if (!opened && json && json.sections && json.sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var tmp = document.createElement('div');
        tmp.innerHTML = json.sections['cart-icon-bubble'];
        var inner = tmp.querySelector('.shopify-section');
        bubble.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
      }
    }
    /* 3. événement pour tout autre tiroir à l'écoute */
    document.dispatchEvent(new CustomEvent('el:cart:open', { bubbles: true, detail: { response: json, opened: opened } }));
  }
  function addToCart(btn) {
    var root = btn.closest('.el-product');
    if (!root || root.__elAdding) return;
    if (!selectionAvailable(root)) {
      setError(root, 'Choisis une senteur disponible pour chaque pot, y compris les pots offerts.');
      return;
    }
    // Conserve une ligne par pot et laisse Shopify appliquer la remise existante.
    var items = selectedPots(root).map(function (pot) { return { id: Number(pot.getAttribute('variant_id')), quantity: 1 }; });
    var returnFocus = document.activeElement || btn;
    root.__elAdding = true;
    setError(root, '');
    syncSelection(root);
    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || (res.json && res.json.status)) {
          throw new Error((res.json && (res.json.description || res.json.message)) || root.getAttribute('data-el-msg-error') || 'Impossible d’ajouter au panier.');
        }
        var status = root.querySelector('[data-selection-status]');
        if (status) status.textContent = items.length + (items.length === 1 ? ' pot ajouté au panier.' : ' pots ajoutés au panier.');
        openCart(res.json, returnFocus);
      })
      .catch(function (error) {
        setError(root, error.message && error.message !== 'Failed to fetch' ? error.message : root.getAttribute('data-el-msg-error') || 'Impossible d’ajouter au panier. Réessaie.');
        // Une erreur déclenchée depuis la barre fixe redevient visible au configurateur.
        var errorBox = root.querySelector('.el-atc-error');
        if (errorBox) errorBox.scrollIntoView({ behavior: 'auto', block: 'center' });
      })
      .finally(function () {
        root.__elAdding = false;
        syncSelection(root);
      });
  }

  /* ---------- Barre fixe : ajoute exactement la sélection du configurateur ---------- */
  function initSticky() {
    document.querySelectorAll('.el-sticky-atc').forEach(function (sticky) {
      var target = document.querySelector('.el-product .el-checkout-button');
      if (!target) return;
      if (sticky.__elSticky && sticky.__elSticky.target === target) return;
      if (sticky.__elSticky) sticky.__elSticky.cleanup();
      var frame = null;
      var observer = null;
      var disposed = false;
      function update() {
        frame = null;
        if (!sticky.isConnected || !target.isConnected) { cleanup(); return; }
        // A scroll jump may skip the CTA without any IntersectionObserver crossing.
        var active = target.getBoundingClientRect().bottom <= 0;
        sticky.classList.toggle('el-active', active);
        sticky.inert = !active;
      }
      function schedule() {
        if (!disposed && frame === null) frame = window.requestAnimationFrame(update);
      }
      function cleanup() {
        if (disposed) return;
        disposed = true;
        if (frame !== null) window.cancelAnimationFrame(frame);
        if (observer) observer.disconnect();
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        window.removeEventListener('pageshow', schedule);
        document.removeEventListener('shopify:section:unload', onUnload);
        sticky.classList.remove('el-active');
        sticky.inert = true;
        delete sticky.__elSticky;
      }
      function onUnload(event) {
        var section = event.target;
        if (section && typeof section.contains === 'function' && (section.contains(sticky) || section.contains(target))) cleanup();
      }
      sticky.__elSticky = { target: target, cleanup: cleanup };
      sticky.inert = true;
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      window.addEventListener('pageshow', schedule);
      document.addEventListener('shopify:section:unload', onUnload);
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(schedule, { threshold: 0 });
        observer.observe(target);
      }
      schedule();
    });
  }

  /* Capture : n’exécute pas une seconde fois les anciens handlers jQuery du socle. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element) || !t.closest('[data-el-pdp]')) return;
    var el;
    if (t.closest('.sentyr-offer')) { e.stopPropagation(); return; }
    if (t.closest('.el-drawer-guide a')) { e.stopPropagation(); return; }
    if ((el = t.closest('.el-question'))) { e.stopPropagation(); e.preventDefault(); toggleFaq(el); return; }
    if ((el = t.closest('.el-scent-guide-label'))) { e.stopPropagation(); e.preventDefault(); openGuide(el.closest('.el-product'), el); return; }
    if ((el = t.closest('.el-mobile-guide-close'))) { e.stopPropagation(); e.preventDefault(); closeGuide(el.closest('.el-drawer-guide')); return; }
    if (t.matches('dialog.el-drawer-guide')) { closeGuide(t); return; }
    if ((el = t.closest('.el-checkout-button'))) { e.stopPropagation(); e.preventDefault(); addToCart(el); return; }
    if (t.closest('.el-sticky-atc-js')) {
      e.stopPropagation(); e.preventDefault();
      var main = document.querySelector('.el-product .el-checkout-button');
      if (main) addToCart(main);
      return;
    }
    if ((el = t.closest('.el-product-media-thumb-item'))) { if (fallbackThumb(el)) e.stopPropagation(); }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof Element) || !t.closest('.el-product[data-el-pdp]')) return;
    if (t.matches('.sentyr-offer-radio')) { e.stopPropagation(); activateOption(t.closest('.sentyr-offer'), true); }
    if (t.matches('.sentyr-scent-select')) { e.stopPropagation(); selectScent(t, true); }
  }, true);

  /* ---------- Init ---------- */
  function init() {
    document.querySelectorAll('.el-product[data-el-pdp]').forEach(function (root) {
      if (root.__elSelectionReady) return;
      root.__elSelectionReady = true;
      root.querySelectorAll('.sentyr-scent-select').forEach(function (select) { selectScent(select, false); });
      var requested = new URL(window.location.href).searchParams.get('offer');
      var initial = /^[1-4]$/.test(requested || '') ? root.querySelector('.sentyr-offer[data_tab="' + requested + '"]') : null;
      initial = initial || currentOffer(root) || root.querySelector('.sentyr-offer');
      if (initial) activateOption(initial, false);
      root.querySelectorAll('dialog.el-drawer-guide').forEach(function (dialog) {
        dialog.addEventListener('close', function () { guideClosed(dialog); });
        dialog.addEventListener('keydown', function (event) { trapGuideFocus(event, dialog); });
      });
    });
    fillDates();
    inlineVideos();
    initSliders(0);
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
